import axios from "axios";
import { removeToken, setToken } from "../../utils/helperFunction";
import { authHeader } from "../../utils/helperFunction";
const UserApi =  {
    LoginService : (body:any) => {
        return axios.post("https://placementportalwebservices.herokuapp.com/api/user/login",body).then(res => {
            return res
        }).catch(e => {
            return Promise.reject(e)
        })
    },
    getUserDetailsService: () =>{
        return axios({
            method:'get',
            url:'https://placementportalwebservices.herokuapp.com/api/user/getuserdetails',
            headers : authHeader()
        }).then(res => res.data)
    },
    postNewNotifications: (body:any) => {
        return axios.post("https://placementportalwebservices.herokuapp.com/api/user/createNewNotification",body,{headers : authHeader()}).then(res => {
            return res
        }).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
            return Promise.reject(e)
        })
    },
    updateNotification: (body:any) => {
        return axios.post("https://placementportalwebservices.herokuapp.com/api/user/updateNotifications",body,{headers : authHeader()}).then(res => {
            return res
        }).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
            return Promise.reject(e)
        })
    },
    getNotifications:() => {
        return axios({
            method:'get',
            url:'https://placementportalwebservices.herokuapp.com/api/user/getNotifications',
            headers : authHeader()
        }).then(res => res.data).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
            return Promise.reject(e)
        })
    }

}
export default UserApi;